import {ApiService} from "../index";
import {APIConfig} from "../../../constants";


const GetFacilityWithProvidersAPICall = () => {
    return ApiService[APIConfig.GET_FACILITY_WITH_PROVIDERS_DETAILS.METHOD](APIConfig.GET_FACILITY_WITH_PROVIDERS_DETAILS.URL);
}

const GetFacilityDetails = (facilityId: string, payload: any = undefined) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_FACILITY_DETAILS.METHOD](APIConfig.GET_FACILITY_DETAILS.URL(facilityId), payload);
}

const GetServiceCategoryDetails = (facilityId: string, payload: any = undefined) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_SERVICE_CATEGORY_DETAILS.METHOD](APIConfig.GET_SERVICE_CATEGORY_DETAILS.URL(facilityId), payload);
}

const GetProviderDetails = (providerId: string, payload: any = undefined) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_PROVIDER_DETAILS.METHOD](APIConfig.GET_PROVIDER_DETAILS.URL(providerId), payload);
}

const GetServiceList = (facilityId: string, categoryId: string, payload: any = undefined) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_SERVICE_LIST.METHOD](APIConfig.GET_SERVICE_LIST.URL(facilityId, categoryId), payload);
}

const GetProviderAvailableDates = (providerId: string, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_PROVIDER_AVAILABLE_DATES.METHOD](APIConfig.GET_PROVIDER_AVAILABLE_DATES.URL(providerId), payload);
}
const GetProviderAvailableTimings = (providerId: string, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_PROVIDER_AVAILABLE_TIMINGS.METHOD](APIConfig.GET_PROVIDER_AVAILABLE_TIMINGS.URL(providerId), payload);
}

const ApplyCouponAPICall = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.APPLY_COUPON_BOOK_APPOINTMENT.METHOD](APIConfig.APPLY_COUPON_BOOK_APPOINTMENT.URL, payload);
}

const BlockTheSlotAPICall = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.BLOCK_THE_SLOT.METHOD](APIConfig.BLOCK_THE_SLOT.URL, payload);
}

const UnBlockTheSlotAPICall = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.UNBLOCK_THE_SLOT.METHOD](APIConfig.UNBLOCK_THE_SLOT.URL, payload);
}

const UnBlockMultipleSlotAPICall = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.UNBLOCK_MULTIPLE_THE_SLOT.METHOD](APIConfig.UNBLOCK_MULTIPLE_THE_SLOT.URL, payload);
}


const BookAppointmentAPICall = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.BOOK_APPOINTMENT_POST.METHOD](APIConfig.BOOK_APPOINTMENT_POST.URL, payload);
}


const AppointmentPaymentAPICall = (payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.APPOINTMENT_PAYMENT_API.METHOD](APIConfig.APPOINTMENT_PAYMENT_API.URL, payload);
}

const GetProvidersListBasedOnSelectedFacilityAndCategory = (facilityId: string, categoryId: string, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.PROVIDER_LIST_CATEGORY_FACILITY_BASED.METHOD](APIConfig.PROVIDER_LIST_CATEGORY_FACILITY_BASED.URL(facilityId, categoryId), payload);
}

const GetCaseListAPICall = (clientId: string, payload: any) => {
    // @ts-ignore
    return ApiService[APIConfig.GET_CASE_LIST_LITE_API_CONFIG.METHOD](APIConfig.GET_CASE_LIST_LITE_API_CONFIG.URL(clientId), payload);
}


const BookAppointmentService = {
    GetFacilityWithProvidersAPICall,
    GetFacilityDetails,
    GetServiceCategoryDetails,
    GetProviderDetails,
    GetServiceList,
    GetProviderAvailableDates, GetProviderAvailableTimings,
    ApplyCouponAPICall,
    BlockTheSlotAPICall,
    UnBlockTheSlotAPICall,
    BookAppointmentAPICall,
    AppointmentPaymentAPICall,
    GetProvidersListBasedOnSelectedFacilityAndCategory,
    GetCaseListAPICall,
    UnBlockMultipleSlotAPICall
}

export default BookAppointmentService;
